import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum ResourceType {
  GOLD = 'GOLD',
  WOOD = 'WOOD',
  STONE = 'STONE',
  SPECIAL = 'SPECIAL',
}

export interface ResourceState {
  resources: Record<ResourceType, number>;
  resourcesEarned: Record<ResourceType, number>;
  resourcesSpent: Record<ResourceType, number>;
}

const initialState: ResourceState = {
  resources: {
    [ResourceType.GOLD]: 100,
    [ResourceType.WOOD]: 50,
    [ResourceType.STONE]: 25,
    [ResourceType.SPECIAL]: 0,
  },
  resourcesEarned: {
    [ResourceType.GOLD]: 100,
    [ResourceType.WOOD]: 50,
    [ResourceType.STONE]: 25,
    [ResourceType.SPECIAL]: 0,
  },
  resourcesSpent: {
    [ResourceType.GOLD]: 0,
    [ResourceType.WOOD]: 0,
    [ResourceType.STONE]: 0,
    [ResourceType.SPECIAL]: 0,
  },
};

const resourceSlice = createSlice({
  name: 'resource',
  initialState,
  reducers: {
    addResource: (state, action: PayloadAction<{ type: ResourceType; amount: number }>) => {
      const { type, amount } = action.payload;
      state.resources[type] += amount;
      state.resourcesEarned[type] += amount;
    },
    spendResource: (state, action: PayloadAction<{ type: ResourceType; amount: number }>) => {
      const { type, amount } = action.payload;
      if (state.resources[type] >= amount) {
        state.resources[type] -= amount;
        state.resourcesSpent[type] += amount;
      }
    },
    setResource: (state, action: PayloadAction<{ type: ResourceType; amount: number }>) => {
      const { type, amount } = action.payload;
      state.resources[type] = amount;
    },
    addWaveReward: (state, action: PayloadAction<{ gold: number; wood: number; stone: number; special: number }>) => {
      const { gold, wood, stone, special } = action.payload;
      
      state.resources[ResourceType.GOLD] += gold;
      state.resourcesEarned[ResourceType.GOLD] += gold;
      
      state.resources[ResourceType.WOOD] += wood;
      state.resourcesEarned[ResourceType.WOOD] += wood;
      
      state.resources[ResourceType.STONE] += stone;
      state.resourcesEarned[ResourceType.STONE] += stone;
      
      state.resources[ResourceType.SPECIAL] += special;
      state.resourcesEarned[ResourceType.SPECIAL] += special;
    },
    resetResources: () => initialState,
  },
});

export const {
  addResource,
  spendResource,
  setResource,
  addWaveReward,
  resetResources,
} = resourceSlice.actions;

export default resourceSlice.reducer; 